<div class="layout-col full">
  <mat-toolbar elderTheme class="flex-none gap-sm">
    <mat-icon class="noselect">keyboard_command_key</mat-icon>
    <elder-header
      class="noselect"
      [header]="'orders.title' | translate"
      [subheader]="'prod_order_commands.title' | translate"
    ></elder-header>

    <span class="flex"></span>

    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <div class="flex layout-col p-sm gap-sm">
    <div class="flex-none layout-row">
      <mat-form-field>
        <elder-select
          appProdOrderCommandSelect
          class="flex large-input"
          valueAsId
          [entityId]="commandType$ | async"
          (entityIdChange)="commandType$.next($event)"
          required
        ></elder-select>
      </mat-form-field>
    </div>

    <elder-table class="flex" [data]="jobs$ | async" matSort>
      <!-- id Column -->
      <ng-container matColumnDef="order.id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header style="width: 10%">
          {{ 'context.id' | translate }}
        </th>
        <td *matCellDef="let job" mat-cell>{{ job.order.id }}</td>
      </ng-container>

      <!-- description Column -->
      <ng-container matColumnDef="order.description">
        <th *matHeaderCellDef mat-header-cell mat-sort-header style="width: 15%">
          {{ 'context.description' | translate }}
        </th>
        <td *matCellDef="let job" mat-cell>
          <div class="layout-col place-center-start">
            <span class="mat-body-2">{{ job.order.description }}</span>
            <span class="mat-subtitle-2">{{ job.order?.project?.description }}</span>
          </div>
        </td>
      </ng-container>

      <!-- Company and Facility Column -->
      <ng-container matColumnDef="order.facility">
        <th *matHeaderCellDef style="width: 10%" mat-header-cell mat-sort-header>
          {{ 'context.facility' | translate }}
        </th>
        <td *matCellDef="let job" mat-cell>
          <mat-chip-set>
            <mat-chip highlighted>{{ job.order?.company }} / {{ job.order?.facility }}</mat-chip>
          </mat-chip-set>
        </td>
      </ng-container>

      <!-- Confirmation state column -->
      <ng-container matColumnDef="order.confirmation.state">
        <th *matHeaderCellDef style="width: 10%" mat-header-cell mat-sort-header>
          {{ 'context.state' | translate }}
        </th>
        <td *matCellDef="let job" mat-cell>
          <mat-chip-set>
            <mat-chip highlighted>{{
              'order_confirmation_state.' + job.order?.confirmationState | translate
            }}</mat-chip>
          </mat-chip-set>
        </td>
      </ng-container>

      <!-- Completion / Production state column -->
      <ng-container matColumnDef="order.completion.state">
        <th *matHeaderCellDef style="width: 10%" mat-header-cell mat-sort-header>
          {{ 'context.production' | translate }}
        </th>
        <td *matCellDef="let job" mat-cell>
          <mat-chip-set>
            <mat-chip highlighted>{{
              'work_order_completion_state.' + job.order?.completionState | translate
            }}</mat-chip>
          </mat-chip-set>
        </td>
      </ng-container>

      <!-- Job state Column -->
      <ng-container matColumnDef="state">
        <th *matHeaderCellDef mat-header-cell mat-sort-header style="width: 10%">
          {{ 'context.state' | translate }}
        </th>
        <td *matCellDef="let jobVar" mat-cell>
          @if (coerceJob(jobVar); as job) {
            @if (job.status$ | async; as status) {
              <div class="layout-col">
                <mat-progress-bar
                  [color]="status.state === JobState.FAILED ? 'warn' : 'primary'"
                  [mode]="status.state === JobState.RUNNING ? 'indeterminate' : 'determinate'"
                  [value]="
                    status.state === JobState.SUCCESS || status.state === JobState.FAILED ? 100 : 0
                  "
                  [matTooltip]="status?.error?.detail"
                >
                </mat-progress-bar>
                <span class="mat-caption">{{ status?.error?.title }}</span>
              </div>
            }
          }
        </td>
      </ng-container>
    </elder-table>
  </div>

  <div class="layout-row place-end-center gap-sm p-sm">
    <button
      mat-flat-button
      *hasRole="['OWNER']"
      (click)="prepareAndRunCommands(true)"
      color="warn"
      [disabled]="!(commandType$ | async)"
    >
      {{ 'actions.run' | translate }} (Force)
    </button>
    <button
      mat-flat-button
      (click)="prepareAndRunCommands(false)"
      color="primary"
      [disabled]="!(commandType$ | async)"
    >
      {{ 'actions.run' | translate }}
    </button>
  </div>
</div>
